import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const SubtitlesApi = {
    getTrackIds: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['subtitles', 'getTrackIds', webinarId], (api) => api.subtitles.getTrackIds(webinarId), options),
    getTracks: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['subtitles', 'getTracks', webinarId], (api) => api.subtitles.getTracks(webinarId), options),
    getTrack: (data: { webinarId: string; trackId: string }, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['subtitles', 'getTrack', data.webinarId, data.trackId], (api) => api.subtitles.getTrack(data), options),
    addOrUpdateTrack: (options?: BaseApiMutationOptions<ApiClient['subtitles']['addOrUpdateTrack']>) =>
        apiMutationOptions((api) => api.subtitles.addOrUpdateTrack, options),
    deleteTrack: (options?: BaseApiMutationOptions<ApiClient['subtitles']['deleteTrack']>) => apiMutationOptions((api) => api.subtitles.deleteTrack, options)
};
